module.exports = __webpack_public_path__ + "img/avatar.5961b4be.png";